
<div class="component-modal-header">
  <span class="modal-title">{{ title }} {{ 'work order' | plural: graphData.value }}</span>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span class="pi pi-times"></span></button>
</div>

<div class="modal-body">
  <auto-table [rows]="rows" [cols]="cols" (onLinkClicked)="goToWorkOrder($event)"></auto-table>
</div>
